import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "full-width" }

import { computed } from "vue";
import { useRoute } from "vue-router";
import { Routes } from "@/router";
import { HeaderBar, LoadingBar } from "./header";
import { GraphBar } from "./graph";


/**
 * Renders the top navigation bar.
 */
const __default__ = {
  name: "AppNavBar",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const currentRoute = useRoute();

const graphVisible = computed(() => currentRoute.path === Routes.ARTIFACT);

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, {
    bordered: "",
    class: "bg-neutral"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_toolbar, { class: "nav-topbar" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(HeaderBar)),
            (graphVisible.value)
              ? (_openBlock(), _createBlock(_unref(GraphBar), { key: 0 }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(LoadingBar))
    ]),
    _: 1
  }))
}
}

})